import { Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
@Component({
  selector: 'lc-date',
  template: `
  <nz-date-picker
nzPlaceHolder="请选择"
[(ngModel)]="value"  
(ngModelChange)="onChange($event)"
>
</nz-date-picker>
  `,
  styles: [
    `
    `
  ],
  providers:[
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LcDateComponent),
      multi: true,
    }
  ] 
})
export class LcDateComponent implements ControlValueAccessor{
  _value: number;
  set value(_value:number){
      this._value=_value;
  };
  get value():number{
    return this._value;
  }
  private onChangeFn: (val: number) => void;
  private onTouchedFn: () => void;

  constructor() {
  
  }
  ngOnInit(): void {

  }
  ngAfterViewInit(): void {
    
  }
  onChange(result: Date): void {
    result.setHours(0);
    result.setMinutes(0);
    result.setSeconds(0);
    console.log(result);
    this.onChangeFn(result.getTime());
  }   
  writeValue(value: number): void {
    this.value = value;
    console.log(this.value);
  }
  registerOnChange(fn: any): void {
    this.onChangeFn = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouchedFn = fn;
  }
}